import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
// import '../../index.css';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OtherBetService } from './OtherBetService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import useToken from '../App/useToken';
import Bet from '../Bets/bets';
import '../UserResponsive.css';

// import { classNames } from 'primereact/utils';
// import { InputNumber } from 'primereact/inputnumber';

function App() {
    return (
        <div>
            <DataTableOtherBets />
        </div>
    );
}

const DataTableOtherBets = () => {

    let emptyProduct = {
        name: "",
        id: "",
        puntaje: "",
        puntaje_inicial: "",
        puntos_partidos: "",
        puntos_especiales: "",
    };

    const [products, setProducts] = useState(null);
    // const [puntajeTotal, setPuntajeTotal] = useState(0);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [visit, setVisit] = useState(0);
    const [summaryType, setSummaryType] = useState('partidos');
    const [auditDialog, setAuditDialog] = useState(false);
    const [auditScope, setAuditScope] = useState('all');
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const betService = new OtherBetService();
    const { token, roles } = useToken();
    const isAdmin = roles.includes('SuperAdmin');
    // const [nombreEquipoLocal, setnombreEquipoLocal] = useState(null);
    // const [nombreEquipoVisitante, setnombreEquipoVisitante] = useState(null);
    // const [nombreUsuario, setNombreUsuario] = useState(null);

    useEffect(() => {
        betService.getPuntajesList(token).then(data => {
            //console.log(data);
            setProducts(data)
        });
        // betService.getPuntajeTotal(token).then(data => {
        //     //console.log(data);
        //     setPuntajeTotal(data['puntajeTotal'])
        //     setNombreUsuario(data['usuario']);
        // });

    }, []);

    const openNew = (e) => {
        //console.log(e.id);
        setVisit(e.id);
        setSummaryType('partidos');
        //setVisit = e;
        setProduct(emptyProduct);
        setSubmitted(false);
        // let _product = {...product};
        // _product['partido_id'] = e.id;
        // _product['teamlGoles'] = "0";
        // _product['teamvGoles'] = "0";
        // setProduct(_product);
        setProductDialog(true);
        //console.log(_product);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
        setProduct(emptyProduct);
    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const hideDeleteProductsDialog = () => {
        setDeleteProductsDialog(false);
    }

    const saveProduct = async e => {
        setSubmitted(true);        
        let _products = [...products];
        let _product = {...product};
        if (_product.partido_id === "" || _product.teamlGoles === "" || _product.teamvGoles === "" ){
            toast.current.show({ severity: 'error', summary: 'Errores', detail: 'Llenar todos los datos!!', life: 3000 });
        }
        else{
            if (product.id) {
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Updated', life: 3000 });
            }
            else {
                let teamlGoles = _product.teamlGoles;
                let teamvGoles = _product.teamvGoles;
                let partido_id = _product.partido_id;
                const newTeamResponse = await betService.newMatch({
                    teamlGoles,
                    teamvGoles,
                    partido_id
                },token);
                if ( newTeamResponse.code === 200){
                    betService.getPartidosList(token).then(data => setProducts(data));
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Apuesta Grabada', life: 3000 });
                }
                else{
                    toast.current.show({ severity: 'error', summary: 'Error al crear la apuesta', detail: newTeamResponse.mensaje, life: 3000 });
                }
                _products.push(_product);
            }
                //setProducts(_products);
            setProductDialog(false);
            setProduct(emptyProduct);
        }
    }

    const deleteProduct = () => {
        let _products = products.filter(val => val.id !== product.id);
        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    }

    const deleteSelectedProducts = () => {
        let _products = products.filter(val => !selectedProducts.includes(val));
        setProducts(_products);
        setDeleteProductsDialog(false);
        setSelectedProducts(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    }

    const onInputChange = (e, name, rowData) => {
        const val = e.value;//(e.target && e.target.value) || '';
        let _product = {...product};
        _product[`${name}`] = val;
        setProduct(_product);
        //console.log(_product);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                {/* <h5>{nombreUsuario} - Puntos = {puntajeTotal}</h5> */}
            </React.Fragment>
        )
    }

    const auditScopeOptions = [
        { label: 'Todos los partidos', value: 'all' },
        { label: 'Fase de grupos', value: 'grupos' },
        { label: '16avos', value: 'dieciseisavos' },
        { label: '8avos', value: 'octavos' },
        { label: '4tos', value: 'cuartos' },
        { label: 'Semifinal', value: 'semifinal' },
        { label: 'Tercer puesto', value: 'tercer_puesto' },
        { label: 'Final', value: 'final' },
    ];

    const openAuditDialog = () => {
        setAuditScope('all');
        setAuditDialog(true);
    }

    const hideAuditDialog = () => {
        setAuditDialog(false);
    }

    const downloadAuditPdf = () => {
        betService.downloadAuditPdf(token, auditScope)
            .then(({ blob, filename }) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                setAuditDialog(false);
                toast.current.show({ severity: 'success', summary: 'PDF generado', detail: 'Auditoria descargada correctamente', life: 3000 });
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 5000 });
            });
    }

    const rightToolbarTemplate = () => {
        if (!isAdmin) {
            return null;
        }

        return (
            <Button label="Exportar auditoria PDF" icon="pi pi-file-pdf" className="p-button-danger" onClick={openAuditDialog} />
        );
    }

    const auditDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideAuditDialog} />
            <Button label="Descargar PDF" icon="pi pi-file-pdf" className="p-button-danger" onClick={downloadAuditPdf} />
        </React.Fragment>
    );

    // const imageBodyTemplate = (rowData) => {
    //     let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoLocal;
    //     return (
    //         <React.Fragment>
    //             <img src={url} 
    //                 onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
    //                 alt={rowData.bandera} className="product-image" />
    //             <span className={`product-badge status-${rowData.equipoLocal.toLowerCase()}`}>{rowData.equipoLocal}</span>
    //         </React.Fragment>
    //     );
    // }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button id={rowData.id} label="VER" icon="pi pi-search" className="p-button-rounded p-button-info" 
                onClick={ () => openNew(rowData) } />
            </React.Fragment>
        );
    }

    // const imageVisitanteBodyTemplate = (rowData) => {
    //     let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoVisitante;
    //     return (
    //         <React.Fragment>
    //             <img src={url} 
    //                 onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
    //                 alt={rowData.banderaEquipoVisitante} className="product-image" />
    //             <span className={`product-badge status-${rowData.equipoVisitante.toLowerCase()}`}>{rowData.equipoVisitante}</span>
    //         </React.Fragment>
    //     );
    // }

    const header = (
        <div className="table-header">
            <h5 className="mx-0 my-1">Puntos Acumulados</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );
    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            {/* <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveProduct} /> */}
        </React.Fragment>
    );
    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
        </React.Fragment>
    );
    const deleteProductsDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductsDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedProducts} />
        </React.Fragment>
    );

    return (
        <div className="datatable-crud-demo user-mobile-page">
            <Toast ref={toast} />

            <div className="card">
                <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate} ></Toolbar>

                <DataTable ref={dt} value={products} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                    className="user-mobile-table ranking-mobile-table"
                    scrollable
                    tableStyle={{ minWidth: '42rem' }}
                    dataKey="id" paginator rows={20} rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll" scrollDirection="both">
                    {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column> */}
                    <Column field="id" header="id" sortable style={{ minWidth: '1rem' , display:"none" }}></Column>
                    <Column field="name" header="Jugador" sortable style={{ minWidth: '8.5rem' }}></Column>
                    <Column field="puntaje" header="Puntaje total" sortable style={{ minWidth: '6.5rem' }}></Column>
                    <Column field="id" header="Ver resumen" body={actionBodyTemplate} sortable style={{ minWidth: '8rem', display:"block" }}></Column>
                    <Column field="puntos_partidos" header="Puntos partidos" sortable style={{ minWidth: '6.5rem' }}></Column>
                    <Column field="puntos_especiales" header="Puntos especiales" sortable style={{ minWidth: '7rem' }}></Column>
                    <Column field="puntaje_inicial" header="Puntaje inicial" sortable style={{ minWidth: '6.5rem' }}></Column>
                </DataTable>
            </div>


            <Dialog visible={productDialog} style={{ width: '90vw' }} header="Ver resumen" modal className="p-fluid user-summary-dialog" footer={productDialogFooter} onHide={hideDialog}>
                    <Dropdown
                        value={summaryType}
                        options={[
                            { label: 'Partidos', value: 'partidos' },
                            { label: 'Apuestas especiales', value: 'especiales' },
                        ]}
                        onChange={(e) => setSummaryType(e.value)}
                        className="mb-3 summary-type-dropdown"
                        placeholder="Selecciona resumen"
                    />
                    {summaryType === 'partidos' ? <Bet visit={visit}/> : <SpecialBetsSummary token={token} userId={visit} />}
            </Dialog>

            <Dialog visible={auditDialog} style={{ width: 'min(92vw, 420px)' }} header="Auditoria de apuestas" modal className="p-fluid" footer={auditDialogFooter} onHide={hideAuditDialog}>
                <div className="field">
                    <label htmlFor="audit_scope">Selecciona el alcance</label>
                    <Dropdown
                        id="audit_scope"
                        value={auditScope}
                        options={auditScopeOptions}
                        onChange={(e) => setAuditScope(e.value)}
                        placeholder="Selecciona auditoria"
                    />
                </div>
                <p className="m-0 text-sm">La opcion todos separa claramente fase de grupos y playoffs para cada jugador.</p>
            </Dialog>



            <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                    {product && <span>Are you sure you want to delete <b>{product.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                    {product && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>
        </div>
    );
}

const SpecialBetsSummary = ({ token, userId }) => {
    const [predictions, setPredictions] = useState([]);
    const [lockMessage, setLockMessage] = useState('');

    useEffect(() => {
        if (!userId) {
            return;
        }

        fetch(process.env.REACT_APP_URL + 'special-predictions/user/' + userId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setLockMessage(data.closed === false ? data.message : '');
                setPredictions(data.predicciones || []);
            });
    }, [token, userId]);

    const longTextTemplate = (field) => (rowData) => {
        return <span className="summary-long-text">{rowData[field] || '-'}</span>;
    }

    if (lockMessage) {
        return <div className="summary-lock-card">{lockMessage}</div>;
    }

    return (
        <DataTable value={predictions} className="user-mobile-table special-summary-table" scrollable tableStyle={{ minWidth: '68rem' }} responsiveLayout="scroll" scrollDirection="both">
            <Column field="categoria" header="Categoria" style={{ minWidth: '11rem' }}></Column>
            <Column field="respuesta_texto" header="Apuesta" body={longTextTemplate('respuesta_texto')} style={{ minWidth: '22rem' }}></Column>
            <Column field="resultado_texto" header="Resultado oficial" body={longTextTemplate('resultado_texto')} style={{ minWidth: '22rem' }}></Column>
            <Column field="puntos" header="Puntos" style={{ minWidth: '6rem' }}></Column>
        </DataTable>
    );
}
export default App;
